import Konva from 'konva';
import { SHAPE_TYPE, Shape, ShapeType } from '../../../types';

export function getShapeRootTarget(shapes: Shape[], target: Konva.Node | null) {
  // use SHAPE_TYPE to get the shape type, if one of the types in SHAPE_TYPE matches the shape type, return the shape type
  let rootTarget = target;

  const types = Object.values(SHAPE_TYPE);

  while (rootTarget?.getParent()) {
    const currentId: string = rootTarget?.attrs?.id;
    if (currentId) {
      const shape = shapes.find((shape) => `shape-${shape.id}` === currentId);
      if (shape && types.includes(shape.type as ShapeType)) {
        return shape;
      }
    }
    rootTarget = rootTarget.getParent();
  }

  return null;
}
